import clsx from 'clsx';
import styles from './NavigationItem.module.scss';
import { PointerEvent, useContext, type ReactNode } from 'react';
import { NavigationContext } from './NavigationContext';
import { useNavigate } from 'react-router-dom';

interface Props {
  children: ReactNode;
  href: string;
  selected?: boolean;
}

export function NavigationItem({ children, href, selected }: Props) {
  const navigationContext = useContext(NavigationContext);
  const navigate = useNavigate();

  const className = clsx(
    styles['root'],
    navigationContext.inline && styles['inline'],
    selected && styles['selected'],
  );

  function onClick(event: PointerEvent<HTMLAnchorElement>) {
    event.preventDefault();
    navigate(event.currentTarget.href);
  }

  return (
    <li className={className}>
      <a href={href} onClick={onClick}>
        {children}
      </a>
    </li>
  );
}
